<template>
  <footer class="footer">
    <div class="container">
      <div class="columns is-mobile is-multiline">
        <div class="column is-half-mobile">
          <div class="subtitle is-6">FEATURES</div>
          <div>
            <!-- Was '/', which sent a visitor who asked for a quote to the
                 homepage to start looking for one. -->
            <nuxt-link no-prefetch to="/quote?src=footer" class="navbar-item">
              Get a quote
            </nuxt-link>
            <nuxt-link no-prefetch to="/claim" class="navbar-item">
              Make a claim
            </nuxt-link>
            <nuxt-link
              no-prefetch
              to="/price-match-promise"
              class="navbar-item"
            >
              Price match promise
            </nuxt-link>
            <nuxt-link no-prefetch to="/hiplok" class="navbar-item">
              Hiplok offer
            </nuxt-link>
            <nuxt-link no-prefetch to="/bike-insurance" class="navbar-item">
              Bike Insurance
            </nuxt-link>
            <nuxt-link no-prefetch to="/what-we-cover" class="navbar-item">
              What We Cover
            </nuxt-link>
            <nuxt-link
              no-prefetch
              to="/bike-theft-insurance"
              class="navbar-item"
            >
              Bike Theft Insurance
            </nuxt-link>
            <nuxt-link
              no-prefetch
              to="/road-bike-insurance"
              class="navbar-item"
            >
              Road Bike Insurance
            </nuxt-link>
            <nuxt-link
              no-prefetch
              to="/mountain-bike-insurance"
              class="navbar-item"
            >
              Mountain Bike Insurance
            </nuxt-link>
            <nuxt-link
              no-prefetch
              to="/commuter-cycle-insurance"
              class="navbar-item"
            >
              Commuter Cycle Insurance
            </nuxt-link>
            <nuxt-link
              no-prefetch
              to="/electric-bike-insurance"
              class="navbar-item"
            >
              E-bike Insurance
            </nuxt-link>
            <nuxt-link
              no-prefetch
              to="/triathlon-cycle-insurance"
              class="navbar-item"
            >
              Triathlon Cycle Insurance
            </nuxt-link>
            <nuxt-link
              no-prefetch
              to="/cargo-bike-insurance"
              class="navbar-item"
            >
              Cargo Bike Insurance
            </nuxt-link>
          </div>
        </div>
        <div class="column is-half-mobile">
          <div class="subtitle is-6">RESOURCES</div>
          <div>
            <nuxt-link no-prefetch to="/policy-information" class="navbar-item">
              Policy Details
            </nuxt-link>
            <nuxt-link no-prefetch to="/faq" class="navbar-item">
              FAQs
            </nuxt-link>
            <nuxt-link
              no-prefetch
              to="/affiliate-programme"
              class="navbar-item"
            >
              Affiliates
            </nuxt-link>
            <br />
            <a
              href="/documents/november_2026/Terms_&_Conditions_11-2026.pdf"
              class="navbar-item"
            >
              Terms & conditions
            </a>
            <nuxt-link
              no-prefetch
              to="/contact-permissions"
              class="navbar-item"
            >
              Data protection
            </nuxt-link>
            <a
              href="/documents/Vulnerable Customer Policy - MAY 2026.pdf"
              class="navbar-item"
            >
              Vulnerable Customer Policy
            </a>
          </div>
        </div>
        <div class="column is-half-mobile">
          <div class="subtitle is-6">COMPANY</div>
          <div>
            <nuxt-link no-prefetch to="/about-us" class="navbar-item">
              About Pedalsure
            </nuxt-link>
            <nuxt-link no-prefetch to="/blog" class="navbar-item">
              Blog
            </nuxt-link>
            <nuxt-link no-prefetch to="/contact-us" class="navbar-item">
              Contact us
            </nuxt-link>
          </div>
        </div>
        <div class="column right">
          <div class="logo">Pedalsure.</div>
          <div class="social-container">
            <ul>
              <li>
                <a
                  href="https://www.facebook.com/pedalsure"
                  rel="noopener"
                  target="_blank"
                >
                  <font-awesome-icon :icon="['fab', 'facebook']" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/ridepedalsure"
                  rel="noopener"
                  target="_blank"
                >
                  <font-awesome-icon :icon="['fab', 'instagram']" />
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/pedalsure"
                  rel="noopener"
                  target="_blank"
                >
                  <font-awesome-icon :icon="['fab', 'twitter']" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- Same component the hub pages render, so the registration numbers
           here and the ones in a page's "who insures you" section cannot
           drift apart. -->
      <RegulatoryStatement variant="footer" />

      <p class="app-version">{{ versionLabel }}</p>

      <!-- <CookieControl>
        <template v-slot:bar>
          <div>
            Our website uses cookies to ensure you get the best experience.
            <nuxt-link no-prefetch to="/contact-permissions">
              Data Protection information
            </nuxt-link>
          </div>
        </template>
      </CookieControl> -->
    </div>
  </footer>
</template>

<script>
/* eslint-disable no-console */
import RegulatoryStatement from '@/components/common/RegulatoryStatement'

export default {
  components: { RegulatoryStatement },
  data: () => {
    return {}
  },
  computed: {
    // Same build info as BuildBadge, kept small and quiet on live.
    versionLabel() {
      return [
        `v${process.env.appVersion}`,
        process.env.appCommit,
        process.env.appCodeLabel,
      ]
        .filter(Boolean)
        .join(' · ')
    },
  },
  created() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1100px;
}
.subtitle,
.title {
  color: $ps-primary;
}
.subtitle {
  margin-bottom: 15px;
}
.navbar-item {
  padding: 0;
  margin: 10px 0;
  color: #303030;
}
.logo {
  font-size: 2rem;
  @include desktop {
    font-size: 2rem;
  }
}
.right {
  text-align: center;
  @include tablet {
    text-align: right;
  }
}
.text {
  padding: 20px 20px 0;
  font-size: 0.6rem;
  border-top: 1px solid $ps-gray;
  @include tablet {
    padding: 30px 20px 0;
  }
  @include desktop {
  }
}
.app-version {
  margin-top: 10px;
  font-size: 0.65rem;
  color: $ps-gray;
  text-align: center;
}
.social-container {
  margin-bottom: 30px;
  li {
    display: inline-block;
    a {
      color: $ps-gray;
      width: 45px;
      height: 45px;
      display: inline-block;
    }
  }
}
.trust-pilot {
  img {
    width: 140px;
    height: 50px;
  }
}
</style>
